import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's142g-s142m01',
    templateUrl: './s142g-s142m01.component.html'
})
export class S142gS142m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    typecd: any = {'value': '_'};
    frznid: any = {'value': '____'};
    toznid: any = {'value': '____'};
    ftrnno: any = {'value': '____'};
    floccd: any = {'value': '___'};
    strnno: any = {'value': '____'};
    sloccd: any = {'value': '___'};
    ttrnno: any = {'value': '____'};
    eftvdt: any = {'value': '__________'};
    exprdt: any = {'value': '____________'};
    alcpct: any = {'value': '______'};
    msgln: any = {};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'typecd', 'frznid', 'toznid', 'ftrnno', 'floccd', 'strnno', 'sloccd', 'ttrnno', 'eftvdt', 'exprdt', 'alcpct', 'msgln'];
    public LINES: number[] = [1, 2, 3, 5, 6, 7, 9, 11, 13, 15, 17, 19, 20, 23, 24];

    ngAfterViewInit(): void {
    }
}
